import sc from "../redux/actions/types/SelectionCriteriaTypes";

export default {
  SC_1_2_3_10_30: {
    items: [sc.SC001_02_03, sc.SC010, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorImpcProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureIMPCCodes:
        selectionCriteria.departureCheckedMailProcessingCenters,
      arrivalIMPCCodes: selectionCriteria.arrivalCheckedMailProcessingCenters,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_11_30: {
    items: [sc.SC001_02_03, sc.SC011, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      arrivalOperatorCodes: selectionCriteria.arrivalCheckedOperators,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_11: {
    items: [sc.SC001_02_03, sc.SC011],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      arrivalOperatorCodes: selectionCriteria.arrivalCheckedOperators,
    }),
  },
  SC_1_2_3_11_TRACKED_ITEMS_IN_PREDES: {
    items: [sc.SC001_02_03, sc.SC0011_TRACKED_ITEMS_IN_PREDES_ETOE],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      arrivalOperatorCodes: selectionCriteria.arrivalCheckedOperators,
    }),
  },
  SC_1_2_3_11_EDI_EXCHANGE: {
    items: [sc.SC001_02_03, sc.SC011_EDI_EXCHANGE],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      arrivalOperatorCodes: selectionCriteria.arrivalCheckedOperators,
    }),
  },
  SC_1_2_3_11_EDI_EXCHANGE_706: {
    items: [sc.SC001_02_03, sc.SC011_EDI_EXCHANGE_706],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      arrivalOperatorCodes: selectionCriteria.arrivalCheckedOperators,
    }),
  },
  SC_1_2_3_11NA: {
    items: [sc.SC001_02_03, sc.SC011NA],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorNaSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
    }),
  },
  SC_1_2_3_11T_30: {
    items: [sc.SC001_02_03, sc.SC011T, sc.SC030],
    scSetApiKey: "1_02_03_11NA_30",
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorNaProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_11NA_30: {
    items: [sc.SC001_02_03, sc.SC011NA, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorNaProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_21: {
    items: [sc.SC001_02_03, sc.SC021],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserCountryUnlocodeSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureUnlocodes: selectionCriteria.departureCheckedUnlocodes,
      arrivalUnlocodes: selectionCriteria.arrivalCheckedUnlocodes,
    }),
  },
  SC_1_2_3_21_70: {
    items: [sc.SC001_02_03, sc.SC021, sc.SC070],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserCountryUnlocodeSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureUnlocodes: selectionCriteria.departureCheckedUnlocodes,
      arrivalUnlocodes: selectionCriteria.arrivalCheckedUnlocodes,
    }),
  },
  SC_1_2_3_60: {
    items: [sc.SC001_02_03, sc.SC060],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorEdiMailboxSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureEdiMailboxes: selectionCriteria.departureCheckedMailboxes,
      arrivalEdiMailboxes: selectionCriteria.arrivalCheckedMailboxes,
    }),
  },
  SC_1_2_3_80: {
    items: [sc.SC001_02_03, sc.SC080],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserMrdOperatorImpcSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureMrdImpcCodes:
        selectionCriteria.departureCheckedMrdMailProcessingCenters,
    }),
  },
  SC_1_2_3_80_mrdHandlerId: {
    items: [sc.SC001_02_03, sc.SC080_mrdHandlerId],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserMrdOperatorImpcSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureMrdImpcCodes:
        selectionCriteria.departureCheckedMrdMailProcessingCenters,
    }),
  },
  SC_1_2_3_11NA_90_30: {
    items: [sc.SC001_02_03, sc.SC011NA, sc.SC090, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorNaCarrierProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      departureOperatorCodes: selectionCriteria.departureCheckedOperators,
      carriers: selectionCriteria.checkedCarriers,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_90: {
    items: [sc.SC001_02_03, sc.SC090],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserCarrierSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      carriers: selectionCriteria.checkedCarriers,
    }),
  },
  SC_1_2_3_91: {
    items: [sc.SC001_02_03, sc.SC091],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserHandlerSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      handlers: selectionCriteria.checkedHandlers,
    }),
  },
  SC_1_2_3: {
    items: [sc.SC001_02_03],
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
    }),
  },
  SC_1_2_3_mrd: {
    items: [sc.SC001_02_03],
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
    }),
  },
  SC_1_2_3_10: {
    items: [sc.SC001_02_03, sc.SC010],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorImpcSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureIMPCCodes:
        selectionCriteria.departureCheckedMailProcessingCenters,
      arrivalIMPCCodes: selectionCriteria.arrivalCheckedMailProcessingCenters,
    }),
  },
  SC_1_2_3_10_COMPARATIVE: {
    items: [sc.SC001_02_03, sc.SC010_COMPARATIVE],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorImpcSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureIMPCCodes:
        selectionCriteria.departureCheckedMailProcessingCenters,
      arrivalIMPCCodes: selectionCriteria.arrivalCheckedMailProcessingCenters,
    }),
  },
  SC_1_2_3_50_51: {
    items: [sc.SC001_02_03, sc.SC050, sc.SC051],
    saveLastUserSelectionRequestActionCreatorKey: "",
    getSaveLastUserSelectionRequestActionCreatorParams: () => ({}),
  },
  SC_1_2_3_100_10_30: {
    items: [sc.SC001_02_03, sc.SC100, sc.SC010, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorImpcProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureIMPCCodes:
        selectionCriteria.departureCheckedMailProcessingCenters,
      arrivalIMPCCodes: selectionCriteria.arrivalCheckedMailProcessingCenters,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  SC_1_2_3_100_OVERVIEW_11_OVERVIEW_30: {
    items: [sc.SC001_02_03, sc.SC100_OVERVIEW, sc.SC010_OVERVIEW, sc.SC030],
    saveLastUserSelectionRequestActionCreatorKey:
      "saveLastUserOperatorImpcProductSelectionRequestActionCreator",
    getSaveLastUserSelectionRequestActionCreatorParams: (
      selectionCriteria
    ) => ({
      direction: selectionCriteria.direction,
      departureIMPCCodes:
        selectionCriteria.departureCheckedMailProcessingCenters,
      arrivalIMPCCodes: selectionCriteria.arrivalCheckedMailProcessingCenters,
      products: selectionCriteria.mailCategoriesWithSubClasses,
    }),
  },
  // All sc items for unit testing
  SC_1_2_3_10_11_21_30_60_70_80_90_91: {
    items: [
      sc.SC001_02_03,
      sc.SC010,
      sc.SC011,
      sc.SC021,
      sc.SC030,
      sc.SC060,
      sc.SC070,
      sc.SC080,
      sc.SC090,
      sc.SC091,
    ],
    saveLastUserSelectionRequestActionCreatorKey: "",
    getSaveLastUserSelectionRequestActionCreatorParams: () => ({}),
  },
};
